import { inject, Service, signal } from '@angular/core';

import { lastValueFrom } from 'rxjs';

import { BaasAppState } from '@lvflanders/bar';

import { VoorwiepickerApiService } from './../../api/services/voorwiepicker-api.service';

/** Internal state service for Startscherm */
@Service({ autoProvided: false })
export class StartschermV2StateService {
    readonly #appState = inject(BaasAppState);
    readonly #voorwiepickerApiService = inject(VoorwiepickerApiService);

    aantalVoorwies: number;
    klantnummer: string;
    klantadres: string;
    klantnaam: string;
    logoutUrl: string;
    rootUrl: string;

    readonly helpLink = signal<string>(undefined);
    identificatienummer: string;
    omschrijvingIdentificatienummer: string;
    //opsplisten zodat de fallback altijd false is als zone = null -> bij !isIntern -> null => false -> true  !!te vermijden!!
    get isIntern(): boolean {
        return this.#appState.basiscontext.zone && this.#appState.basiscontext.zone.toUpperCase() == 'I';
    }
    get isExtern(): boolean {
        return this.#appState.basiscontext.zone && this.#appState.basiscontext.zone.toUpperCase() == 'E';
    }

    get isDEV(): boolean {
        return this.#appState.toepassing.omgeving && this.#appState.toepassing.omgeving.toUpperCase() == 'DEV';
    }
    get isTST(): boolean {
        return this.#appState.toepassing.omgeving && this.#appState.toepassing.omgeving.toUpperCase() == 'TST';
    }
    get isPRD(): boolean {
        return this.#appState.toepassing.omgeving && this.#appState.toepassing.omgeving.toUpperCase() == 'PRD';
    }

    showDialog = signal({ help: false, user: false });
    toggleDialog(type: string): void {
        setTimeout(() => {
            const newState = { ...this.showDialog() };
            newState[type] = !newState[type];
            this.showDialog.set(newState);
        });
    }

    async refreshVoorwiePicker(): Promise<void> {
        if (this.#appState.basiscontext.voorwie) {
            const klantInfoVoorwie = await lastValueFrom(this.#voorwiepickerApiService.getKlantinfoVoorwie());
            if (klantInfoVoorwie) {
                this.klantnummer = klantInfoVoorwie.klantnummer;
                this.klantnaam = klantInfoVoorwie.klantnaam;
                this.klantadres = klantInfoVoorwie.klantadres;
                this.identificatienummer = klantInfoVoorwie.identificatienummer;
                this.omschrijvingIdentificatienummer = klantInfoVoorwie.omschrijvingIdentificatienummer;
            }
        } else {
            this.klantnummer = null;
            this.klantnaam = null;
            this.klantadres = null;
        }
    }
}
